import {Component, OnInit} from '@angular/core';
import {EquipamentosService} from "./equipamentos.service";
import {EquipamentosModel} from "./equipamentos.model";
import {Global} from "../global";
import {Components} from "../shared/components/components";
import {TranslateService} from '@ngx-translate/core';
import {Router} from "@angular/router";
import {Funcoes} from "../funcoes";
import {LoginService} from "../login/login.service";

declare let swal, moment: any;

@Component({
  selector: 'app-equipamentos',
  templateUrl: './equipamentos.component.html'
})
export class EquipamentosComponent extends Components implements OnInit {

  equipamentos: EquipamentosModel[] = [];
  privilegioUsuario = {"editar": false, "consultar": false};

  listNotificacoes = [];

  constructor(
    private equipamentosService: EquipamentosService,
    public global: Global,
    protected translate: TranslateService,
    protected router: Router,
    public func: Funcoes,
    private loginService: LoginService
  ) {
    super();

    this.loginService.getUserInfo().subscribe(data => {
      for(let i in data.privilegios){
        if(data.privilegios[i].acao[0].url == 'equipamentos'){
          this.privilegioUsuario.consultar = data.privilegios[i].consultar;
          this.privilegioUsuario.editar = data.privilegios[i].editar;
        }
      }
    });
  }

  ngOnInit() {
    this.carregandoTabela = true;
    this.equipamentosService.getPaginacao(1,this.itensPorPagina)
      .subscribe(data => {
        this.equipamentos = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
        this.carregandoTabela = false;

        if (this.global.debug) {
          console.log(this.equipamentos);
        }
      },
      error => {
        this.func.showErro(error.json());
        this.carregandoTabela = false;
      });

    // busca lista de notificacoes
    this.equipamentosService.getNotificacoes()
      .subscribe(res => {
          console.log('listNotificacoes', res);
          this.listNotificacoes = res.Payload;
        },
        error => {
          this.func.showErro(error.json());
        });
  }

  delete(equipamento) {
    let equipamentos = this.equipamentos;
    let equipamentosService = this.equipamentosService;

    let self = this;

    swal({
        title: this.func.traduzir('front.voceTemCerteza'),
        text: this.func.traduzir('front.desejaDeletarEquipamento')+equipamento.descricao,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: this.func.traduzir('front.confirmar'),
        cancelButtonText: this.func.traduzir('front.cancelar'),
        closeOnConfirm: true
      },
      function(){
        if(self.global.debug == true){
          console.log(equipamentos);
        }

        let index = equipamentos.indexOf(equipamento);
        equipamentos.splice(index, 1);

        equipamentosService.apagar(equipamento.id_equipamento)
          .subscribe(res => {
              //swal(this.func.traduzir('front.deletado'), this.func.traduzir('front.removidoComSucesso'), "success");
              self.equipamentos = equipamentos;
            },
            err => {
              // Revert the view back to its original state
              equipamentos.splice(index, 0, equipamento);
              self.equipamentos = equipamentos;

              self.func.showErro(err.json());
            });

      });
  }

  getPage(pagina){
    this.paginaAtual = pagina;
    this.carregandoTabela = true;
    this.equipamentosService.getPaginacao(pagina,this.itensPorPagina)
      .subscribe(data => {
        this.equipamentos = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
        this.carregandoTabela = false;
      },
      error => {
        this.func.showErro(error.json());
        this.carregandoTabela = false;
      });
  }

  criaMoment(data = false){
    return (data) ? moment(data) : moment().hours(0).minutes(0).seconds(0).milliseconds(0);
  }

  addNotificacao(){
    this.listNotificacoes.push({'email': ''});
  }

  removeNotificacao(i){
    this.listNotificacoes.splice(i, 1);
  }

  changeNotificacao(e, indice){
    console.log(indice, e.target.value);
    console.log(this.func.validaEmail(e.target.value));

    if(!this.func.validaEmail(e.target.value)){
      this.func.alerta(this.func.traduzir('front.erro'), this.func.traduzir('front.emailInvalido'), 'erro');
    }

    let qtdEmail = 0;
    for(let i in this.listNotificacoes){
      if(this.listNotificacoes[i].email == e.target.value){
        qtdEmail++;
      }
    }

    if(qtdEmail > 1){
      this.func.alerta(this.func.traduzir('front.erro'), this.func.traduzir('front.emailJaCadastradoNotificacao'), 'erro');
      this.listNotificacoes[indice].email = '';
    }

  }

  updNotificacoes(){

    // valida a lista de emails
    let qtdEmail = 0;
    let emailErro = false;
    for(let i in this.listNotificacoes){
      qtdEmail++;
      if(!this.func.validaEmail(this.listNotificacoes[i].email)){
        emailErro = true;
      }
    }

    // verifica se teve algum email cadastrado
    if(qtdEmail == 0){
      this.func.alerta(this.func.traduzir('front.erro'), this.func.traduzir('front.nenhumEmailCadastradoNotificacao'), 'erro');
      return false;
    }

    // verifica se teve algum email invalido
    if(emailErro){
      this.func.alerta(this.func.traduzir('front.erro'), this.func.traduzir('front.umOuMaisEmailsInvalidos'), 'erro');
      return false;
    }


    qtdEmail = 0;
    for(let x in this.listNotificacoes) {
      for (let i in this.listNotificacoes) {
        if ((this.listNotificacoes[i].email == this.listNotificacoes[x].email) && (i != x)) {
          qtdEmail++;
        }
      }
    }

    if(qtdEmail > 0){
      this.func.alerta(this.func.traduzir('front.erro'), this.func.traduzir('front.umOuMaisEmailsRepetidos'), 'erro');
    }

    // salva lista de emails
    this.equipamentosService.updNotificacoes(this.listNotificacoes)
      .subscribe(res => {})
  }

}



// WEBPACK FOOTER //
// ./src/app/equipamentos/equipamentos.component.ts